import { IFlatTourBookingSchedule } from '../../types/flatTourBooking/flatTourBookingSchedule';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EFlatTourBookingActionTypes {
  SetScheduleData = 'flatTourBooking/setScheduleData',
}

export type TSetScheduleData = ITypedReduxAction<EFlatTourBookingActionTypes.SetScheduleData, IFlatTourBookingSchedule>;

export const setScheduleData = actionGenerator<EFlatTourBookingActionTypes.SetScheduleData, IFlatTourBookingSchedule>(
  EFlatTourBookingActionTypes.SetScheduleData,
);
